import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const EachWayTermsList = withConfig(theme => styled('ul', { label: 'EachWayTermsList' })`
    font-size: ${theme.star.fontSize.xSmall};
    width: 100%;
`);

export const EachWayTermsListElement = styled('li', { label: 'EachWayTermsListElement' })`
    display: inline-block;
    margin-right: 5px;
    &:last-of-type {
        margin-right: 0;
    }
`;
